var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 6,
    viewBox: "0 0 6 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vertical container",
    clipPath: "url(#clip0_626_14165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.30188 0.576105C3.85933 0.53819 4.41151 0.704515 4.85528 1.04401C5.29904 1.3835 5.60404 1.87294 5.71328 2.42089C5.81674 2.93983 5.73793 3.47763 5.49176 3.944L5.75097 4.90677C5.77051 4.97936 5.74961 5.05685 5.69621 5.10976C5.64281 5.16267 5.56513 5.18286 5.49272 5.16266L4.54373 4.89781C4.07948 5.14647 3.54294 5.22868 3.02395 5.12895C2.47526 5.02351 1.98371 4.72192 1.64115 4.28052C1.29859 3.83912 1.12843 3.2881 1.16248 2.73041C1.19652 2.17271 1.43244 1.64648 1.82615 1.25003C2.21986 0.853579 2.74444 0.614019 3.30188 0.576105ZM4.60105 1.37631C4.23803 1.09859 3.7863 0.962523 3.33027 0.993539C2.87425 1.02456 2.44511 1.22053 2.12303 1.54486C1.80094 1.86918 1.60795 2.29967 1.5801 2.7559C1.55225 3.21213 1.69145 3.6629 1.97169 4.02399C2.25193 4.38509 2.65404 4.63181 3.10291 4.71806C3.55178 4.80432 4.0167 4.72421 4.41081 4.49271C4.45977 4.46395 4.51832 4.45633 4.573 4.47159L5.25148 4.66094L5.06579 3.97122C5.05133 3.91752 5.05885 3.86027 5.08668 3.81213C5.31545 3.41642 5.39233 2.95095 5.30296 2.50269C5.21359 2.05443 4.96408 1.65404 4.60105 1.37631Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_626_14165"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 5.02079,
    height: 5.02079,
    fill: "white",
    transform: "translate(0.946777 0.358887)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.d31a3cf74bcd32661ac0dd81a78699ac.svg";
export { ForwardRef as ReactComponent };